import React, { createContext, useContext, useMemo } from 'react';

type ContentFrameLayout = {
  framedScroll: boolean;
};

const ContentFrameLayoutContext = createContext<ContentFrameLayout>({
  framedScroll: false,
});

export const ContentFrameLayoutProvider: React.FC<{
  framedScroll: boolean;
  children: React.ReactNode;
}> = ({ framedScroll, children }) => {
  const value = useMemo(() => ({ framedScroll }), [framedScroll]);

  return (
    <ContentFrameLayoutContext.Provider value={value}>
      {children}
    </ContentFrameLayoutContext.Provider>
  );
};

export const useContentFrameLayout = (): ContentFrameLayout =>
  useContext(ContentFrameLayoutContext);
